import { render } from "./TimelineEntry.vue?vue&type=template&id=52b5f00a&scoped=true&ts=true"
import script from "./TimelineEntry.vue?vue&type=script&lang=ts"
export * from "./TimelineEntry.vue?vue&type=script&lang=ts"

import "./TimelineEntry.vue?vue&type=style&index=0&id=52b5f00a&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/wdw-vue build and deploy Teledata PROD/wdw-vue-widgets/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52b5f00a"]])

export default __exports__